<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>用户列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-input v-model="filters.name" placeholder="姓名" style="min-width: 240px;"
                      @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="showAddDialog">添加</el-button>
            <!-- <el-button type="primary" @click="showOrgDialog">组织</el-button> -->
          </el-form-item>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table :data="users" highlight-current-row border style="width: 100%;">
        <el-table-column type="index" width="60" fixed="left"></el-table-column>
        <el-table-column prop="userName" label="用户名" width="120" fixed="left" sortable></el-table-column>
        <el-table-column prop="realName" label="姓名" width="120" fixed="left" sortable></el-table-column>
        <el-table-column prop="nickName" label="昵称" width="120" sortable></el-table-column>
        <el-table-column prop="sex" label="性别" width="100" :formatter="formatSex" sortable></el-table-column>
        <el-table-column prop="certType" label="证件类型" width="120" :formatter="formatCertType" sortable></el-table-column>
        <el-table-column prop="certNo" label="证件号码" width="180" sortable></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="120" sortable></el-table-column>
        <el-table-column prop="email" label="邮箱" min-width="160" sortable></el-table-column>
        <el-table-column prop="birth" label="出生日期" min-width="160" sortable></el-table-column>
        <el-table-column prop="address" label="户口地" min-width="180" sortable></el-table-column>
        <el-table-column prop="liveAddress" label="居住地" min-width="180" sortable></el-table-column>
        <el-table-column prop="headPicUrl" label="头像" min-width="180" sortable></el-table-column>
        <el-table-column prop="status" label="状态" :formatter="formatStatus" sortable></el-table-column>
        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button size="mini" @click="showEditDialog(scope.$index,scope.row)">编辑</el-button>
            <el-button v-if="scope.row.orgId!='0'" size="mini" type="danger" @click="removeUser(scope.$index,scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]"
          :page-size="10" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
      </el-col>
      <!-- 添加界面 -->
      <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <table style="width: 100%;">
            <tr>
              <td colspan="2">
                <el-form-item label="所属机构" prop="userName" class="clear-margin-bottom">
                  <TreeSelect ref="addtreeSelect" 
                    :props="props"
                    :options="orgs"
                    :value="valueId"
                    :clearable="isClearable"
                    :accordion="isAccordion"
                    @getValue="getValue($event)"
                   >
                  </TreeSelect>  
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="用户名" prop="userName" class="clear-margin-bottom">
                  <el-input v-model="addForm.userName" auto-complete="off" @keyup.native="check_zh"></el-input>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="密码" prop="password" class="clear-margin-bottom">
                  <el-input v-model="addForm.password" show-password auto-complete="new-password"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="姓名" prop="realName" class="clear-margin-bottom">
                  <el-input v-model="addForm.realName" auto-complete="off"></el-input>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="昵称" prop="nickName" class="clear-margin-bottom">
                  <el-input v-model="addForm.nickName" auto-complete="off"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="证件类型" prop="certType" class="clear-margin-bottom">
                  <el-select v-model="addForm.certType" clearable placeholder="请选择">
                    <el-option v-for="item in dictCertType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="证件号码" prop="certNo" class="clear-margin-bottom">
                  <el-input v-model="addForm.certNo" auto-complete="off"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="性别" prop="sex" class="clear-margin-bottom">
                  <el-select v-model="addForm.sex" clearable placeholder="请选择">
                    <el-option v-for="item in dictSex" :key="item.value" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="出生日期" prop="birth" class="clear-margin-bottom">
                  <el-date-picker type="date" placeholder="出生日期" v-model="addForm.birth"></el-date-picker>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="手机号" prop="mobile" class="clear-margin-bottom">
                  <el-input v-model="addForm.mobile" auto-complete="off"></el-input>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="邮箱" prop="email" class="clear-margin-bottom">
                  <el-input type="email" v-model="addForm.email" auto-complete="off"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                 <el-form-item label="户口地址" prop="address" class="clear-margin-bottom">
                  <el-input v-model="addForm.address" auto-complete="off"></el-input>
                </el-form-item>
              </td>
              <td>
                 <el-form-item label="居住地址" prop="liveAddress" class="clear-margin-bottom">
                  <el-input v-model="addForm.liveAddress" auto-complete="off"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="用户状态" prop="roleIds">
                  <el-select v-model="addForm.status" clearable placeholder="请选择">
                    <el-option v-for="item in dictStatus" :key="item.value" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="角色" prop="roleIds" width="300px">
                  <el-select v-model="addForm.roles" multiple collapse-tags placeholder="请选择">
                    <el-option v-for="item in roles" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </td>
            </tr>
          </table>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
      <!-- 编辑界面 -->
      <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
          <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <table style="width: 100%;">
             <tr>
              <td colspan="2">
                <el-form-item label="所属机构" prop="userName" class="clear-margin-bottom">
                  <TreeSelect ref="treeSelect" 
                    :props="props"
                    :options="orgs"
                    :value="valueId"
                    :clearable="isClearable"
                    :accordion="isAccordion"
                    @getValue="getValue($event)"
                   >
                  </TreeSelect>  
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="用户名" prop="userName" class="clear-margin-bottom">
                  <el-input v-model="addForm.userName" auto-complete="off" @keyup.native="check_zh"></el-input>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="密码" class="clear-margin-bottom">
                  <el-input v-model="addForm.password" show-password auto-complete="new-password"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="姓名" prop="realName" class="clear-margin-bottom">
                  <el-input v-model="addForm.realName" auto-complete="off"></el-input>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="昵称" prop="nickName" class="clear-margin-bottom">
                  <el-input v-model="addForm.nickName" auto-complete="off"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="证件类型" prop="certType" class="clear-margin-bottom">
                  <el-select v-model="addForm.certType" clearable placeholder="请选择">
                    <el-option v-for="(item,index) in dictCertType" :key="index" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="证件号码" prop="certNo" class="clear-margin-bottom">
                  <el-input v-model="addForm.certNo" auto-complete="off"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="性别" prop="sex" class="clear-margin-bottom">
                  <el-select v-model="addForm.sex" clearable placeholder="请选择">
                    <el-option v-for="(item,index) in dictSex" :key="index" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="出生日期" prop="birth" class="clear-margin-bottom">
                  <el-date-picker type="date" placeholder="出生日期" v-model="addForm.birth"></el-date-picker>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="手机号" prop="mobile" class="clear-margin-bottom">
                  <el-input v-model="addForm.mobile" auto-complete="off"></el-input>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="邮箱" prop="email" class="clear-margin-bottom">
                  <el-input type="email" v-model="addForm.email" auto-complete="off"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                 <el-form-item label="户口地址" prop="address" class="clear-margin-bottom">
                  <el-input v-model="addForm.address" auto-complete="off"></el-input>
                </el-form-item>
              </td>
              <td>
                 <el-form-item label="居住地址" prop="liveAddress" class="clear-margin-bottom">
                  <el-input v-model="addForm.liveAddress" auto-complete="off"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>
                <el-form-item label="用户状态" prop="roleIds">
                  <el-select v-model="addForm.status" clearable placeholder="请选择">
                    <el-option v-for="item in dictStatus" :key="item.value" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </td>
              <td>
                <el-form-item label="角色" prop="roleIds" width="300px">
                  <el-select v-model="addForm.roles" multiple collapse-tags placeholder="请选择">
                    <el-option v-for="(item,index) in roles" :key="index" :label="item.roleName" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </td>
            </tr>
          </table>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
  import API from "../../api/api_user";
  import ROLE_API from "../../api/api_role";
  import ORG_API from "../../api/api_org";
  import TreeSelect from '@/components/selectTree/treeSelect.vue';

  export default {
    components: { TreeSelect },
    data() {
      return {
        isClearable:true,      // 可清空（可选）
        isAccordion:true,      // 可收起（可选）
        valueId:'',            // 初始ID（可选）
        props:{                // 配置项（必选）
          value: 'id',
          label: 'name',
          children: 'children',
          // disabled:true
        },

        filters: {
          name: ""
        },
        loading: false,
        users: [],
        roles: [],
        roleIds: [],
        dictSex: [],
        dictCertType: [],
        dictStatus: [],
        orgs:[],
        total: 0,
        page: 1,
        limit: 10,
        addFormVisible: false,
        editFormVisible: false,
        orgDialogVisible: false,
        editFormRules: {
          userName: [
            {required: true, message: "请输入用户名", trigger: "blur"},
            {
              required: true,
              pattern: /^[a-zA-Z0-9_-]{4,16}$/,
              message: '用户名为4到16位字符，只能为字母，数字，下划线，减号',
              trigger: 'blur'
            }
          ],
          password: [
            {required: true, message: "请输入密码", trigger: "blur"},
            { min: 8,max:20,message: '长度8-20个字符', trigger: 'blur' }
          ],
          realName: [
            {required: true, message: "请输入姓名", trigger: "blur"},
            { min: 2,message: '长度大于2个字符', trigger: 'blur' },
          ]
        },
        editForm: {
          username: "",
          password: "",
          name: "",
          email: "",
          roleIds: []
        },
        //新增相关数据
        addFormVisible: false, //新增界面是否显示
        addLoading: false,
        addFormRules: {
          userName: [
            {required: true, message: "请输入用户名", trigger: "blur"},
            {
              required: true,
              pattern: /^[a-zA-Z0-9_-]{4,16}$/,
              message: '用户名为4到16位字符，只能为字母，数字，下划线，减号',
              trigger: 'blur'
            }
          ],
          password: [
            {required: true, message: "请输入密码", trigger: "blur"},
            { min: 8,max:20,message: '长度8-20个字符', trigger: 'blur' }
          ],
          realName: [
            {required: true, message: "请输入姓名", trigger: "blur"},
            { min: 2,message: '长度大于2个字符', trigger: 'blur' },
          ]
        },
        addForm: {
          username: "",
          password: "",
          name: "",
          email: "",
          roles: [],
        }
      };
    },
    methods: {
      //文本框不能输入中文
      check_zh(){
        let that = this;
        that.addForm.userName = that.addForm.userName.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g, '');
      },
      // 取值
      getValue(value){
        let that =this;
        this.valueId = value;
        that.addForm.orgId=value;
        //根据单位id，查询角色数据
        let valuetemp = value==null?"":value;
        //if(valuetemp){
          let params={
            orgId:valuetemp
          }
          that.loading=true;
          console.log(params);
          ROLE_API.findByOrgId(params)
          .then(
              function (result) {
                that.loading = false;
                if (result && result.code == 200) {
                  that.addForm.roles=[];
                  that.roles=result.data;
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
         // }
      },
      //性别显示转换
      formatSex: function (row, column) {
        var text = '未知';
        this.dictSex.forEach(function(item){
          if(item.value == row.sex){
            text = item.name;
          }
        });
        return text;
      },
      //证件类型显示转换
      formatCertType: function (row, column) {
        var text = '';
        this.dictCertType.forEach(function(item){
          if(item.value === row.certType){
            text = item.name;
          }
        });
        return text;
      },
      //用户状态转换
      formatStatus: function (row, column) {
        var text = '';
        this.dictStatus.forEach(function(item){
          if(item.value == row.status){
            text = item.name;
          }
        });
        return text;
      },
      handleSizeChange(val) {
        this.limit = val;
        this.search();
      },
      handleCurrentChange(val) {
        this.page = val;
        this.search();
      },
      handleSearch() {
        this.total = 0;
        this.page = 1;
        this.search();
      },
      //获取用用户列表
      search: function () {
        let that = this;
        let params = {
          page: that.page,
          limit: that.limit,
          name: that.filters.name
        };

        that.loading = true;
        API.findList(params)
          .then(
            function (result) {
              that.loading = false;
              if (result && result.code == 200) {
                that.total = result.data.page.total;
                that.users = result.data.page.rows;
                that.dictSex = result.data.dictSex;
                that.dictCertType = result.data.dictCertType;
                that.dictStatus = result.data.dictStatus;
              }
            },
            function (err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      },
      showAddDialog: function () {
        let that = this;
        //第一次打开，还没有渲染组件，所以需要判断下是否已经初始化
        if(that.$refs.addtreeSelect){
          that.$refs.addtreeSelect.clearHandle();
        }
        this.addFormVisible = true;
        that.roles = [];
        that.orgs=[];
        that.addForm={
          username: "",
          password: "",
          name: "",
          email: "",
          roles: [],
          orgId:''
        };
        ORG_API.getSelectOrg("")
          .then(
            function (result) {
              that.loading = false;
              if (result && result.code == 200) {
                console.log(result.data);
                that.orgs=result.data;
              }
            },
            function (err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function (error) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      },
      showEditDialog: function (index, row) {
        let that = this;
        that.valueId=null;
        //第一次打开，还没有渲染组件，所以需要判断下是否已经初始化
        if(that.$refs.treeSelect){
          //清空org数据
          that.$refs.treeSelect.clearHandle();
        }
        this.editFormVisible = true;
        that.orgs=[];
        that.addForm={
          username: "",
          password: "",
          name: "",
          email: "",
          roles: [],
          orgId:''
        };
        that.roles=[];
        API.findUserRoles({orgId:row.orgId,userId: row.id}).then(function (result) {
          that.orgs=result.data.org;
          that.roles = result.data.role;
          console.log(that.roles);
          API.getDetial({userId: row.id})
              .then(
                function (result) {
                  that.loading = false;
                  if (result && result.code === 200) {
                    //赋值其他值
                    that.addForm = result.data;
                    that.addForm.sex=that.addForm.sex==null?'':that.addForm.sex.toString();
                    that.addForm.status = that.addForm.status==null?"":that.addForm.status.toString();
                    //赋值结构
                    that.valueId = result.data.orgId=="0"?null:result.data.orgId;
                    //赋值角色
                    console.log(that.addForm.roles);
                    let temp=[];
                    that.addForm.roles.forEach((item)=>{
                      console.log(item);
                      temp.push(item.toString());
                    });
                    that.addForm.roles=temp;
                  }else{
                    that.$message.error({
                      showClose: true,
                      message: result.msg,
                      duration: 1500
                    });
                  }
                },
                function (err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function (error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
        })
        .catch(function (error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });;
       
      },
      addSubmit: function () {
        let that = this;
        this.$refs.addForm.validate(valid => {
          if (valid) {
            that.loading = true;
            let params = Object.assign({}, this.addForm);
            params.roleIds = that.roleIds
            console.log(params);
            //加载
            API.addUser(params)
                .then(
                    function (result) {
                      that.loading = false;
                      if (result && result.code == 200) {
                        that.$message.success({
                          showClose: true,
                          message: "新增成功",
                          duration: 2000
                        });
                        that.addFormVisible = false;
                        that.search();
                      }
                      else{
                          that.$message.error({
                          showClose: true,
                          message: result.msg,
                          duration: 2000
                        });
                      }
                    },
                    function (err) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                    });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                    showClose: true,
                    message: "请求出现异常",
                    duration: 2000
                    });
                });
          }
        });
      },
      editSubmit: function () {
        let that = this;
        that.loading = true;
            let params = Object.assign({}, that.addForm);
            API.editUser(params).then(function (result) {
              if (result && result.code == 200) {
                that.$message.success({
                  showClose: true,
                  message: "修改成功",
                  duration: 2000
                });
                that.editFormVisible = false;
                that.search();
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.msg,
                  duration: 2000
                });
              }
            },
            function (err) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                    });
                    }
            )
             .catch(function (error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
      },
      removeUser: function (index, row) {
        let that = this;
        this.$confirm("确认删除该记录吗?", "提示", {type: "warning"})
          .then(() => {
            that.loading = true;
            API.removeUser(row.id)
              .then(
                function (result) {
                  that.loading = false;
                  if (result && result.code === 200) {
                    that.$message.success({
                      showClose: true,
                      message: "删除成功",
                      duration: 1500
                    });
                    that.search();
                  }else{
                    that.$message.error({
                      showClose: true,
                      message: result.msg,
                      duration: 1500
                    });
                  }
                },
                function (err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function (error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {
          });
      }
    },
    mounted() {
      this.handleSearch();
    }
  };
</script>

<style scoped>
  .clear-margin-bottom {
    margin-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// list.vue?ec063d50